var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('balance',{attrs:{"ws":_vm.ws}}),_c('div',{staticClass:"col-md-12"},[_c('card',{attrs:{"title":_vm.$t('reports.soon')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }